import React from 'react';
import { Section } from '../../models/globals';
import { ProductSectionProps } from '../common/ProductSection';
import { ExpandableHtmlSection } from '../common/ExpandableHtmlSection';

interface FaqSectionProps extends ProductSectionProps {
    items: Section[];
}

const FaqSection: React.FC<FaqSectionProps> = (faq) => {
    return <ExpandableHtmlSection {...faq} />;
};

export { FaqSection, FaqSectionProps };
